export default [
  {
    path: "/4xWO2q8qtQpLrF2kI6SI",
    children: [
      {
        path: "",
        name: "transactionList",
        meta: {
          title: "Transactions",
          authRequired: true,
          acc: ["y59766"],
        },
        component: () => import("../views/transactions/index.vue"),
      },
      {
        path: "08b0b9c4502818bd4ee2b79c/id?",
        name: "transactionview",
        meta: {
          title: "Transactions",
          authRequired: true,
          acc: ["y59766"],
        },
        component: () => import("../views/transactions/view.vue"),
      },
    ],
  },
];
